// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* eslint-disable @typescript-eslint/no-explicit-any */
import { GET_HANH_TRINH_DON_HANG, GET_HANH_TRINH_DON_HANG_DONE } from "./constant";

export const GetHanhTrinhDonHangAction = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_HANH_TRINH_DON_HANG,
    payload,
    callback
  };
};

export const GetHanhTrinhDonHangActionDone = (data: any) => ({
  type: GET_HANH_TRINH_DON_HANG_DONE,
  payload: data
})